export enum RoleUser {
  ADMIN = 'Amministratore',
  ADMIN_VIEWER = 'Amministratore Viewer',
  EDITOR = 'Editor',
  VIEWER = 'Viewer',
}

export const getLabelRoleUser = (id: string) => {
  const roleUser: any = RoleUser;
  return roleUser[id];
};
